import { render } from "./admin-trajectory-processing.vue?vue&type=template&id=5d909b7e&ts=true&lang=pug"
import script from "./admin-trajectory-processing.vue?vue&type=script&lang=ts"
export * from "./admin-trajectory-processing.vue?vue&type=script&lang=ts"

import "./admin-trajectory-processing.vue?vue&type=style&index=0&id=5d909b7e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__